import OpenAI from 'openai';
import { PATH_PREFIX } from '@config/constant';
import { getModuleLogger } from '@utils/logger';
const logger = getModuleLogger('openai-sdk');
const STAINLESS_NULL_HEADERS = {
    'x-stainless-arch': null,
    'x-stainless-lang': null,
    'x-stainless-os': null,
    'x-stainless-package-version': null,
    'x-stainless-retry-count': null,
    'x-stainless-runtime': null,
    'x-stainless-runtime-version': null,
    'x-stainless-timeout': null,
};
/**
 * 构建 LLM 代理 baseURL，路径与 chat-sdk 保持一致
 */
export function buildBaseURL(isRuntime = false) {
    const proto = location.protocol.slice(0, -1);
    const dns = `${location.host}${PATH_PREFIX}`;
    return `${proto}://${dns}/api/xy/${isRuntime ? 'runtime' : 'design'}/llm`;
}
/**
 * 从浏览器 URL 提取 projectId / pageId，作为 query 参数传给后端
 */
export function getBrowserContextQuery() {
    if (typeof window === 'undefined') {
        return {};
    }
    const urlParams = new URLSearchParams(window.location.search);
    const projectId = urlParams.get('projectid') || urlParams.get('projectId');
    const pageId = urlParams.get('pageid') || urlParams.get('pageId');
    return {
        ...(projectId && { projectId }),
        ...(pageId && { pageId }),
    };
}
/**
 * 创建已配置好 baseURL、鉴权与请求头的 OpenAI 客户端。
 * 调用方直接使用官方 OpenAI SDK API，例如：
 *   client.chat.completions.create({ ...params, stream: false }, { headers, query })
 *   client.chat.completions.create({ ...params, stream: true }, { headers, query, signal })
 */
export function createOpenAIClient(options = {}) {
    const { isRuntime = false, defaultHeaders = {} } = options;
    const baseURL = buildBaseURL(isRuntime);
    logger.info('[openai-sdk] 初始化', { isRuntime, baseURL });
    return new OpenAI({
        baseURL,
        apiKey: '',
        dangerouslyAllowBrowser: true,
        defaultHeaders: {
            ...STAINLESS_NULL_HEADERS,
            ...defaultHeaders,
        },
        fetch: (url, init) => fetch(url, Object.assign({}, init, { credentials: 'include' })),
    });
}
export default createOpenAIClient;
